var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "my-loading",
          rawName: "v-my-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "contract"
    },
    [
      !_vm.loading
        ? _c("div", { staticClass: "main" }, [
            _vm.config.startTime > new Date().getTime()
              ? _c("div", [
                  _vm.$route.query.backgroundColor == "day"
                    ? _c("img", {
                        staticClass: "waitImg",
                        attrs: {
                          src: require("../../assets/images/activityWaitIcon.png")
                        }
                      })
                    : _c("img", {
                        staticClass: "waitImg",
                        attrs: {
                          src: require("../../assets/images/activityWaitIcon_moon.png")
                        }
                      })
                ])
              : _vm.config.endTime < new Date().getTime()
              ? _c("div", [
                  _vm.$route.query.backgroundColor == "day"
                    ? _c("img", {
                        staticClass: "endImg",
                        attrs: {
                          src: require("../../assets/images/activityEndIcon.png")
                        }
                      })
                    : _c("img", {
                        staticClass: "endImg",
                        attrs: {
                          src: require("../../assets/images/activityEndIcon_moon.png")
                        }
                      })
                ])
              : _c("div", [
                  _vm.istrue
                    ? _c("div", [
                        _vm.$route.query.backgroundColor == "day"
                          ? _c("img", {
                              staticClass: "sucImg",
                              attrs: {
                                src: require("../../assets/images/activityFailIcon.png")
                              }
                            })
                          : _c("img", {
                              staticClass: "sucImg",
                              attrs: {
                                src: require("../../assets/images/activityFailIcon_moon.png")
                              }
                            })
                      ])
                    : _c("div", [
                        _vm.$route.query.backgroundColor == "day"
                          ? _c("img", {
                              staticClass: "sucImg",
                              attrs: {
                                src: require("../../assets/images/activitySuccessIcon.png")
                              }
                            })
                          : _c("img", {
                              staticClass: "sucImg",
                              attrs: {
                                src: require("../../assets/images/activitySuccessIcon_moon.png")
                              }
                            })
                      ])
                ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.text_variables))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.query.backgroundColor == "day"
        ? _c("img", {
            staticClass: "bottomBg",
            attrs: { src: require("../../assets/images/bottomBg.png") }
          })
        : _c("img", {
            staticClass: "bottomBg",
            attrs: { src: require("../../assets/images/bottomBg_moon.png") }
          })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef1f7a58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef1f7a58","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/contractCompetition/activityIsSignUp.vue
// module id = 5xb9
// module chunks = 0